// module factories are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("l8aYy");
__webpack_require__("WvSPy");
__webpack_require__("VEKBq");
var __webpack_exports__ = __webpack_require__("XaEU4");
